import React from 'react';
import GameBoard from '../components/GameBoard';

const GamePlay = () => {
    return (
        <React.Fragment>
            <GameBoard />
        </React.Fragment>
    );
}

export default GamePlay;